import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-log-pointer-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './reset-log-pointer-dialog.html',
  styleUrl: './reset-log-pointer-dialog.css'
})
export class ResetLogPointerDialog {
  @Input() name: string = '';
  @Input() lastName: string = '';
  @Input() submitting: boolean = false;

  @Output() closed = new EventEmitter<void>();
  @Output() submit = new EventEmitter<{ daysAgo: number }>();

  daysAgoInput: number | string | null = 0;
  error: string | null = null;

  constructor(private translate: TranslateService) {}

  onCancel(): void {
    this.closed.emit();
  }

  onSubmit(): void {
    const raw = this.daysAgoInput;
    if (raw === null || raw === '') {
      this.error = this.translate.instant('reset_log_pointer_dialog.error_non_negative');
      return;
    }
    const asNumber = typeof raw === 'number' ? raw : Number(String(raw).trim());
    const isInteger = Number.isInteger(asNumber);
    if (!Number.isFinite(asNumber) || !isInteger || asNumber < 0) {
      this.error = this.translate.instant('reset_log_pointer_dialog.error_non_negative');
      return;
    }
    this.error = null;
    this.submit.emit({ daysAgo: asNumber });
  }
}


